import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetCertificationUserCounts = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['certificationUserCounts'],
    queryFn: () => analyticsService.getCertificationUserCounts(),
    refetchOnWindowFocus: false,
  });
};

export const useGetStudentsCount = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsStudentsCount'],
    queryFn: () => analyticsService.getStudentsCount(),
    refetchOnWindowFocus: false,
  });
};

export const useGetOrganizationsSummary = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsOrganizationsSummary'],
    queryFn: () => analyticsService.getOrganizationsSummary(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetWebinarsSummary = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsWebinarsSummary'],
    queryFn: () => analyticsService.getWebinarsSummary(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetActiveSubscriptionsKpi = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsActiveSubscriptionsKpi'],
    queryFn: () => analyticsService.getActiveSubscriptionsKpi(),
    refetchOnWindowFocus: false,
  });
};

export const useGetCertRevenueBreakdown = (months = 6) => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsCertRevenueBreakdown', months],
    queryFn: () => analyticsService.getCertRevenueBreakdown(months),
    refetchOnWindowFocus: false,
  });
};

export const useGetMonthlyRefunds = (months = 6) => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsMonthlyRefunds', months],
    queryFn: () => analyticsService.getMonthlyRefunds(months),
    refetchOnWindowFocus: false,
  });
};

export const useGetMonthlyDiscountedSalesItems = (months = 6) => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsMonthlyDiscountedSalesItems', months],
    queryFn: () => analyticsService.getMonthlyDiscountedSalesItems(months),
    refetchOnWindowFocus: false,
  });
};

export const useGetMonthlySubscriptionActivity = (months = 6) => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsMonthlySubscriptionActivity', months],
    queryFn: () => analyticsService.getMonthlySubscriptionActivity(months),
    refetchOnWindowFocus: false,
  });
};

export const useGetMonthlyChurnRates = (months = 6) => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsMonthlyChurnRates', months],
    queryFn: () => analyticsService.getMonthlyChurnRates(months),
    refetchOnWindowFocus: false,
  });
};

export const useGetMonthlyRecurringRevenue = (months = 6) => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsMonthlyRecurringRevenue', months],
    queryFn: () => analyticsService.getMonthlyRecurringRevenue(months),
    refetchOnWindowFocus: false,
  });
};

export const useGetMonthlySubscriptionRevenue = (months = 6) => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsMonthlySubscriptionRevenue', months],
    queryFn: () => analyticsService.getMonthlySubscriptionRevenue(months),
    refetchOnWindowFocus: false,
  });
};

export const useGetMasterCertifiedCount = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsMasterCertifiedCount'],
    queryFn: () => analyticsService.getMasterCertifiedCount(),
    refetchOnWindowFocus: false,
  });
};

export const useGetCertificationCompletion = () => {
  const analyticsService = useServices().analyticsService;
  return useQuery({
    queryKey: ['analyticsCertificationCompletion'],
    queryFn: () => analyticsService.getCertificationCompletion(),
    refetchOnWindowFocus: false,
  });
};
